module.exports = __webpack_public_path__ + "img/GENERAL-FRONX-BOOSTERGREEN-2.ddb48b26.jpg";